/* eslint no-param-reassign: "error"*/
import { EntityUtil } from '@xengage/gw-portals-util-js';
import _ from 'lodash';
import PolicyLineExtensionConfiguration from '../PolicyLineExtensionConfiguration';
import Contact from './Contact';

function Claim(data) {
    if (data) {
        data.contacts = _.map(data.contacts, c => {
            return new Contact(c);
        });

        if (data.claimReporter) {
            data.claimReporter.reportedBy = this.findContact(
                data,
                data.claimReporter.reportedBy
            );
        }

        data.mainContact = this.findContact(data, data.mainContact);

        _.each(
            data.relatedContacts,
            _.bind(function (rc) {
                rc.contact = this.findContact(data, rc.contact);
            }, this)
        );

        _.extend(this, data);
        // Convert loss date to a date object.
        this.lossDate = new Date(this.lossDate).toJSON();
    } else {
        this.lossDate = new Date().toJSON();
        this.contacts = [];
        this.relatedContacts = [];
    }
    if (this.policy && !this.lossType) {
        PolicyLineExtensionConfiguration.setLossDetails(this);
    }
    PolicyLineExtensionConfiguration.mixinLobDraftDataExtensions(this);
}

Claim.prototype.nextId = () => {
    return EntityUtil.nextId();
};

Claim.prototype.getLossCategory = function () {
    let category = null;
    if (this.lossType && this.lossCause) {
        switch (this.lossType) {
            case 'AUTO':
                switch (this.lossCause) {
                    case 'theftentire':
                    case 'theftparts':
                        category = 'theft';
                        break;
                    case 'glassbreakage':
                        category = 'glass';
                        break;
                    case 'otherobjcoll':
                        category = 'other';
                        break;
                    default:
                        category = 'collision';
                        break;
                }
                break;

            case 'PR':
                switch (this.lossCause) {
                    case 'fire':
                        category = 'fire';
                        break;
                    case 'waterdamage':
                    case 'mold':
                        category = 'waterdamage';
                        break;
                    case 'burglary':
                    case 'vandalism':
                    case 'riotandcivil':
                        category = 'burglary';
                        break;
                    default:
                        category = 'other';
                }
                break;
            default:
                break;
        }
    }
    return category;
};

Claim.prototype.createContact = function (data) {
    const contactData = _.extend({}, data, { tempID: this.nextId() });
    const newContact = new Contact(contactData);
    this.contacts.push(newContact);
    return newContact;
};

Claim.prototype.availableContacts = function () {
    return this.contacts;
};

Claim.prototype.availableRelatedContacts = function () {
    return _.filter(
        this.contacts,
        function (c) {
            // eslint-disable-line prefer-arrow-callback
            return (
                _.find(this.relatedContacts, {
                    contact: c,
                }) === undefined
            );
        }.bind(this)
    );
};

Claim.prototype.addRelatedContact = function (c) {
    const contact = c || this.createContact();
    this.relatedContacts.unshift({
        role: 'witness',
        injured: false,
        contact: contact,
    });
};

Claim.prototype.removeRelatedContact = function (rc) {
    const idx = _.findIndex(this.relatedContacts, {
        contact: rc,
    });
    this.relatedContacts.splice(idx, 1);
};

Claim.prototype.changePolicy = function (policy) {
    if (!this.policy || this.policy.policyNumber !== policy.policyNumber) {
        this.policy = policy;
        this.publicID = null;
        this.lossLocation = null;
        this.contacts = [];
        this.mainContact = null;
        this.relatedContacts = [];
        this.contacts = [];
    }
};

Claim.prototype.findContact = function (claim, contact, matchKeysArray) {
    return EntityUtil.findMatchingEntity(claim.contacts, contact, {
        Ctor: Contact,
        keys: matchKeysArray,
    });
};

export default Claim;
